<template>
  <div class="persion">
    <van-nav-bar
      class="barColor"
      :title="$t('昵称')"
      :right-text="$t('提交')"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <div class="persion-card">
      <div class="nickName">{{ $t('请输入昵称') }}</div>
    </div>
    <div class="persion-card">
      <van-form @submit="onClickRight" ref="form">
        <van-field
          v-model="nickName"
          :placeholder="$t('请输入您的昵称')"
          class="nameText"
          :rules="[
            {
              pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]+$/,
              message: $t('昵称只能包含字母、数字和汉字'),
            },
          ]"
        />
      </van-form>
    </div>
  </div>
</template>
<script>
import { Field, Icon, Divider, NavBar, Toast, Form } from 'vant'
import Vue from 'vue'
import { postUserInfo, queryStaffToekn } from '@/services/api'

Vue.use(Icon)
Vue.use(Field)
Vue.use(Divider)
Vue.use(Form)
Vue.use(NavBar)
Vue.use(Toast)

export default {
  name: 'UserInfo',
  components: {
    NavBar,
  },
  data() {
    return {
      nickName: '',
      user: {},
      roleId: '',
      companyId: '',
      id: '',
      faceUrl: '',
    }
  },
  methods: {
    onClickLeft() {
      this.$router.back()
    },
    async onClickRight() {
      let params = {}
      if (this.nickName === '') {
        this.nickName = ''
      } else {
        await this.$refs.form.validate()
        params = { name: this.nickName }
      }
      await this.UserInfo()
      this.$router.push({
        path: '/persionInfo',
        params: params,
        query: { refresh: true },
      })
    },
    async UserInfo() {
      let user = JSON.parse(localStorage.getItem('user'))
      let newUser = await queryStaffToekn({ token: user.token })
      this.roleId = newUser.roleList.map((item) => item.id).join(',')

      user.nickName = this.nickName // 更新 user 对象中的 nickName 属性
      await postUserInfo({
        id: user.id,
        nickName: this.nickName,
        companyId: user.companyId,
        roleId: this.roleId,
        facePhoto: newUser.facePhoto || '',
      })
      localStorage.setItem('user', JSON.stringify(user)) // 存储更新后的user对象
      this.$router.push({
        params: { nickName: this.nickName }, // 将更新后的姓名作为参数传递给下面的页面
      })
      Toast(this.$t('修改成功'))
    },
  },
}
</script>
<style lang="less" scoped>
.van-nav-bar {
  background: #00bdff;
}
.persion /deep/ .van-nav-bar__title {
  color: white !important;
  font-size: 16px;
}
.persion /deep/ .van-nav-bar .van-icon {
  color: white !important;
}

.persion /deep/ .van-nav-bar__text {
  color: white !important;
}

.persion {
  height: 100%;

  .persion-card {
    height: 70px;
    padding: 0px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fefffe;
    font-size: 16px;
    line-height: 24px;
    border-bottom: 1px solid #ebebeb;

    .nickName {
      font-weight: bold;
    }
  }
}

.barColor {
  .van-nav-bar__left,
  .van-nav-bar__text {
    color: #000000 !important; // 使用 !important 来强制覆盖默认样式
  }
}
</style>
